module.exports = __webpack_public_path__ + "static/media/bg.d719065b.png";